/* global customElements */
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {BaseComponent} from '../basecomponent.js';
import {ElementUtil} from '../../utils/elementUtil.js';

/* 
 * Window with a title and close button
 * Defaults to modal  
 * This is mostly desktop component; using slide over for mobile
 *  
 */
export class FloatingWindow extends BaseComponent {
	
	static get properties() {
		return {
			headertext: {type: String},			
			closable: {type: String},
			resizable: {type: String},
			maxiumizable: {type: String},
			shadeable: {type: String},
			width: {type: String},
			height: {type: String},
			top: {type: String},
			left: {type: String},
			modal: {type: String}
		};
	}

	constructor() {
		super();
		this.headertext = '';		
		this.closable = 'true';
		this.modal = 'true';
		this.resizable = 'true';
		this.maxiumizable = 'true';
		this.shadeable = 'true';		
		this.width = '50%';
		this.height = '50%';
				
		var floatWindow = this;
		setTimeout(function(){
			floatWindow.init();
		});
	}
	
	render() {	
		return html`			
			<slot></slot>
		`;
	}
		
	init() {
		var floatWindow = this;
	
		floatWindow.classList.add("hide");
	
		var styles =  ElementUtil.create({
			tag: 'style',
			innerHTML: `
				.mask {
					position: absolute;
					top: 0px;
					left: 0px;
					bottom: 0px;
					right: 0px;
					color: white;
					text-align: center;
					vertical-align: middle;
					align-content: center;
					background-color: rgba(0,0,0, 0.5);
					backdrop-filter: blur(5px);
				}
				
				.main-window {
					position: absolute; 
					top: 0px; 
					left: 0px; 
					width: ${floatWindow.width}; 
					height: ${floatWindow.height}; 					
					box-shadow: 0px 0px 11px 3px #405656;
					border-radius: 3px 3px 3px 3px;
					overflow: hidden;
				}
				
				.header {
					font-size: 22px;
					border-radius: 3px 3px 0px 0px;
					width: auto; 
					background-color: #383838; 
					color: white; 
					padding: 5px; 
					min-height: 30px;
					border-bottom: 3px solid ${window.DL.Branding.navBackgroundColor};
					user-select: none;
				}
			
				.tools {
					position: absolute;
					top: 5px;
					right: 8px;
					color: white;					
				}
				.tool-btn {
					margin-left: 5px;
					margin-right: 5px;
			
				}
			
				.tool-btn-icon {
					height: 15px;
				}
				
				.tool-btn:hover {
					opacity: .8;
					cursor: pointer;
				}
			
				.content-panel {
					overflow: auto;
					height: calc(99% - 40px);
				}
				
				.maximize {					
					width: 100%;
					height: 100%;
				}
			
				.shade {
					height: 40px;
				}
			
				.resizer {
					position: absolute;
					right: 0px;
					bottom: 0px;
					width: 20px;
					height: 20px;
					cursor: se-resize;
					background-color: grey;
					user-select: none;
				}
			`
		});
		
		var modalMask = ElementUtil.create({
			tag: 'div',
			'class': 'mask ' + (floatWindow.modal === 'true' ? '' : 'hide')
		});
		
		floatWindow.mainPanel = ElementUtil.create({
			tag: 'div',
			'class': 'floating-window-background main-window',			
			children: [
				{
						tag: 'div',
						'class': 'header',
						slot: 'toolbar',							
						innerHTML: floatWindow.headertext,
						listeners: {
							mousemove: function(event) {							
								dragHandler(event, floatWindow.mainPanel);
							}
						},
						children: [
							{
								tag: 'span',
								itemid: 'tool',
								'class': 'tools',					
								children: [
									{
										tag: 'span',
										itemid: 'shade',
										'class': 'tool-btn',
										title: 'shade',
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:minus" class="tool-btn-icon"></vaadin-icon>',
										listeners: {
											click: function(event) {
												floatWindow.shade();
											}
										}
									},
									{
										tag: 'span',
										itemid: 'max',
										'class': 'tool-btn',
										title: 'Maximize',
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:browser" class="tool-btn-icon"></vaadin-icon>',
										listeners: {
											click: function(event) {
												if (floatWindow.maxed) {
													floatWindow.restore();
													event.target.title = 'Maximize';
													floatWindow.maxed = false;
												} else {
													floatWindow.maximize();
													event.target.title = 'Restore';
													floatWindow.maxed = true;
												}
											}
										}
									},
									{
										tag: 'span',
										itemid: 'close',
										'class': 'tool-btn',
										title: 'close',
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:close" class="tool-btn-icon"></vaadin-icon>',
										listeners: {
											click: function(event) {
												floatWindow.close();
											}
										}
									}
								]
							}
						]
					},
					{
						tag: 'div',
						itemid: 'content',
						'class': 'content-panel',
						slot: 'primary'
					},
				
				{
					tag: 'div',
					itemid: 'resizer',
					'class': 'resizer',
					trustedInnerHTML: true,
					innerHTML: '<vaadin-icon icon="vaadin:corner-lower-right"></vaadin-icon>',
					listeners: {
						mousemove: function(event) {							
							resizeHandler(event, floatWindow.mainPanel);
						}
					}
				}				
			]
		});
		
		if (!floatWindow.shadeable || floatWindow.resizable === 'false') {
			ElementUtil.query(floatWindow.mainPanel, 'shade').classList.add('hide');
		}

		if (!floatWindow.maxiumizable || floatWindow.resizable === 'false') {
			ElementUtil.query(floatWindow.mainPanel, 'max').classList.add('hide');
		}

		if (!floatWindow.closable || floatWindow.resizable === 'false') {
			ElementUtil.query(floatWindow.mainPanel, 'close').classList.add('hide');
		}
		
		if (!floatWindow.resizable || floatWindow.resizable === 'false') {
			ElementUtil.query(floatWindow.mainPanel, 'resizer').classList.add('hide');
		}
		
		var resizeHandler = function(event, target) {
			if (event.buttons === 1) {
				var newY = target.offsetHeight + event.movementY;
				var newX = target.offsetWidth + event.movementX;
				
				target.style.height = newY + 'px';
				target.style.width = newX + 'px';
			}			
		};
		
		var dragHandler = function(event, target) {
			if (event.buttons === 1) {
				var newY = (Number(target.style.top.replace('px', '')) + event.movementY);
				var newX = (Number(target.style.left.replace('px', '')) + event.movementX);

				var w = window.innerWidth;
				var h = window.innerHeight;

				if ((newX + target.offsetWidth) > w) {
					newX = (w - target.offsetWidth);
				} else if (newX < 0) {
					newX = 0;
				}
				
				if ((newY + target.offsetHeight) > h) {
					newY = (h - target.offsetHeight);
				} else if (newY < 0) {
					newY = 0;
				}
				
				target.style.top = newY + 'px';
				target.style.left = newX + 'px';
			}
		};
		
		floatWindow.append(styles, modalMask, floatWindow.mainPanel);
		
		document.body.append(floatWindow);
		
		var readyEvent = new CustomEvent('ready', { detail: '' });
		floatWindow.dispatchEvent(readyEvent);	
	}
	
	show() {
		var floatWindow = this;
				
		floatWindow.classList.remove("hide");
		
		//set initial position (after render)
		setTimeout(function(){
			var w = window.innerWidth;
			var h = window.innerHeight;

			if (floatWindow.top) {
				floatWindow.mainPanel.style.top = floatWindow.top;
			} else {
				floatWindow.mainPanel.style.top = ((h/2) - (floatWindow.mainPanel.offsetHeight/2)) + 'px';
			}

			if (floatWindow.left) {
				floatWindow.mainPanel.style.left = floatWindow.left;
			} else {
				floatWindow.mainPanel.style.left = ((w/2) - (floatWindow.mainPanel.offsetWidth/2)) + 'px';
			}
			
			//for mobile (100 maybe artfact of the simulators)
			if (floatWindow.mainPanel.offsetWidth > (w-100) || floatWindow.mainPanel.offsetHeight > (h-100)) {
				floatWindow.maximize();
				ElementUtil.query(floatWindow.mainPanel, 'max').classList.add('hide');
				ElementUtil.query(floatWindow.mainPanel, 'shade').classList.add('hide');
			}			
			
		});		
		
	}
	
	getContentPanel() {
		var floatWindow = this;
		return ElementUtil.query(floatWindow.mainPanel, 'content');
	}
	
	addToConentPanel(element) {
		var floatWindow = this;
		
		ElementUtil.query(floatWindow.mainPanel, 'content').append(element);		
	}	
	
	close() {
		var floatWindow = this;
		
		floatWindow.remove();	
		
		var readyEvent = new CustomEvent('close', { detail: '' });
		floatWindow.dispatchEvent(readyEvent);		
	}
	
	maximize() {
		var floatWindow = this;
		floatWindow.mainPanel.oldWidth = floatWindow.mainPanel.offsetWidth + 'px';
		floatWindow.mainPanel.oldHeight = floatWindow.mainPanel.offsetHeight + 'px';
				
		floatWindow.mainPanel.classList.add('maximize');
		
		floatWindow.mainPanel.oldtop = floatWindow.mainPanel.style.top;
		floatWindow.mainPanel.oldleft = floatWindow.mainPanel.style.left;
		floatWindow.mainPanel.style.top = '0px';
		floatWindow.mainPanel.style.left = '0px';
		
		floatWindow.mainPanel.style.width = '100%';
		floatWindow.mainPanel.style.height = '100%';	
		
		ElementUtil.query(floatWindow.mainPanel, 'resizer').classList.add('hide');
	}
	
	restore() {
		var floatWindow = this;
		
		floatWindow.mainPanel.classList.remove('maximize');
		floatWindow.mainPanel.style.top = floatWindow.mainPanel.oldtop;
		floatWindow.mainPanel.style.left = floatWindow.mainPanel.oldleft;
						
		floatWindow.mainPanel.style.width = floatWindow.mainPanel.oldWidth;
		floatWindow.mainPanel.style.height = floatWindow.mainPanel.oldHeight;
		
		if (floatWindow.resizable) {
			ElementUtil.query(floatWindow.mainPanel, 'resizer').classList.remove('hide');
		}
		
	}
	
	shade() {
		var floatWindow = this;
		if (floatWindow.shaded) {
			floatWindow.mainPanel.style.height = floatWindow.mainPanel.oldHeightNotShaded;
			floatWindow.shaded = false;
			if (floatWindow.resizable === 'true') {
				ElementUtil.query(floatWindow.mainPanel, 'resizer').classList.remove('hide');
			}
		} else {
			floatWindow.mainPanel.oldHeightNotShaded = floatWindow.mainPanel.style.height;
			floatWindow.mainPanel.style.height = '40px';			
			floatWindow.shaded = true;
			
			ElementUtil.query(floatWindow.mainPanel, 'resizer').classList.add('hide');
		}
		
		floatWindow.mainPanel.classList.toggle('shade');
	}
	
};
customElements.define('dl-window', FloatingWindow);
